<template>
  <div class="jbdfyh-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
          @changeCompany="changeCompany"
        ></tab-tree>
      </div>
      <div class="content">
        <div class="search-box box">
          <time-search
            ref="timeSearch"
            :control="{ data: timeType }"
            @timeControlChange="timeControlChange"
            @timeControlClick="TimeControlClick"
          ></time-search>
        </div>
        <div class="grid-content">
          <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
          <div class="table-wrap">
            <el-table
              @cell-click="cellClick"
              show-summary
              :data="tableData"
              ref="table"
              border
              id="table"
              :header-cell-style="tableHeaderColor"
              :cell-style="tableCellStyle"
              :summary-method="getSummaries"
            >
              <template v-for="(item, index) in tablecoumn">
                <el-table-column
                  :key="index"
                  :prop="item.prop"
                  :label="item.label"
                  :align="item.align ? item.align : 'center'"
                  :width="item.width"
                ></el-table-column>
              </template>
            </el-table>
          </div>
          <div class="echarts-wrap">
            <div class="tablebox">
              <nk-chart-xl
                :data="chartData"
                :timeTitle="timeTitle"
              ></nk-chart-xl>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import uuidv1 from "uuid/v1";
import TabTree from "@/components/common/TabTree.vue";
import { findDataByParam } from "@/utils/index.js";
import TimeSearch from "@/components/common/TimeSearch.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import echarts from "echarts";
import dateTool from "@/utils/dateTool.js";
import handleData from "@/utils/handleData.js";
import { isNull } from "util";
import * as fpg from "@/utils/fpg.js";
import NkChartXl from "@/components/page/power/NkChartXl.vue";
import ResizeContainer from "@/components/common/resizeContainer.vue";
export default {
  components: {
    TabTree,
    TimeSearch,
    BtnShow,
    NkChartXl,
    ResizeContainer,
  },
  data() {
    return {
      tabShow: true, //左边的树是否显示
      viewTreeData: [], //树数据
      selectedMeasure: {
        //当前选中的树数据
        measureId: "",
        measureName: "",
      },
      timeElem: {}, //当前的时间参数
      timeType: [{ type: "year", label: "年" }],
      pointCode: "228", //code码
      pointNumber: "0", //num值
      tableData: [], //表格数据
      tablecoumn: [
        {
          prop: "name",
          label: "统计项",
          width: 350,
          show: true,
          align: "left",
        },
      ],
      isLast: true,
      isLoad: false,
      loadIndex: "",
      loadTime: {
        fromDate: null,
        toDate: null,
      },
      chartData: [
        {
          data: [[]],
          xData: [],
          tip: ["需量"],
          title: "需量曲线图",
          timeData: [[], []],
        },
      ],
      timeTitle: "",
    };
  },
  mounted() {},
  methods: {
    async changeCompany(companyId) {
      //获取树数据
      let res = await this.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
        companyId,
        "/power/jbdfyh",
        null
      );
      this.viewTreeData = findDataByParam("viewTree", true, res.data); //数据赋值
    },
    async getData() {
      let result = await this.$api.measuring.getMeasuringValueMaxMinMonth(
        this.selectedMeasure.measureId,
        this.timeElem.startTime,
        this.timeElem.endTime,
        this.pointCode,
        this.pointNumber
      );
      let maxdata = result.data.map(k => k.max);
      this.changeXdata("M月", maxdata);
      let [obj, tempdata, colum] = [{}, [], []];
      let temp = handleData.createXData(
        this.timeElem.dateType,
        this.timeElem.startTime,
        this.timeElem.endTime
      );
      temp.forEach((item, index) => {
        item.value = "-";
        maxdata.forEach((item2) => {
          if (item.title == item2.time) {
            item.value = (Number(item2.value) * 32).toFixed(2); //当前值乘以变比32
          }
        });
        if (index == 0) {
          obj["name"] = "基本电费(需量)";
        }
        obj[item.title] = item.value;
      });
      this.tablecoumn = colum;
      obj["allvalue"] = this.sumData(temp);
      let res = await this.$api.measure.getMeasureProperty(
        this.selectedMeasure.measureId,
        ""
      );
      let resdata = res.data;
      if (resdata.length > 0) {
        let juge = resdata.find((res2) => {
          return res2.name == "__ratedCapacity" || res2.name == "DeclareCapacity";
        });
        if (juge) {
          var num = juge.value.replace(/[^0-9]/gi, "");
          this.rongvalue = (Number(num) * 23).toFixed(2);
        } else {
          this.rongvalue = "-";
        }
      }
      let temp1 = handleData.createXData(
        this.timeElem.dateType,
        this.timeElem.startTime,
        this.timeElem.endTime
      );
      let obj1 = {};
      temp1.forEach((item, index) => {
        item.value = "-";
        if (index == 0) {
          obj1["name"] = "基本电费(容量)";
          colum.push({ prop: "name", label: "统计项" });
        }
        if (temp[index].value == "-") {
          obj1[item.title] = "-";
        } else {
          obj1[item.title] = this.rongvalue;
          item.value = this.rongvalue;
        }
        colum.push({ prop: item.title, label: item.title });
      });
      colum.push({ prop: "allvalue", label: "合计项" });
      obj1["allvalue"] = this.sumData(temp1);
      tempdata.push(obj1);
      tempdata.push(obj);
      this.tableData = tempdata;
      // this.fillEcharts(this.timeElem.startTime,this.timeElem.endTime);
      let startTime, endTime;
      let time = new Date();
      time.setMonth(new Date().getMonth() - 1);
      startTime = dateTool.format(new Date(time), "yyyy-MM") + "/01 00:00:00";
      endTime = dateTool.format(new Date(), "yyyy-MM") + "/01 00:00:00";
      if (this.loadTime.fromDate) {
        //第二次传入的是点击表格的时间
        this.fillEcharts(this.loadTime.fromDate, this.loadTime.toDate);
      } else {
        //第一次传入的时间是当前月
        this.fillEcharts(startTime, endTime);
      }
    },
    changeXdata(changetype, arr) {
      arr.filter((res) => {
        res.time = dateTool.format(
          new Date(new Date(res.time).getTime()),
          changetype
        );
        res.value = Number(res.value).toFixed(2);
      });
    },
    sumData(data) {
      let num;
      data.forEach((res) => {
        if (!isNaN(Number(res.value))) {
          if (!num) {
            num = Number(res.value);
          } else {
            num += Number(res.value);
          }
        }
      });
      if (!isNaN(Number(num))) {
        num = Number(num).toFixed(2);
      } else {
        num = "-";
      }
      return num;
    },
    tabTreeDefault(e) {
      //首次加载树时执行，保留默认的树选择
      this.selectedMeasure = e;
      this.getData(); //获取数据
    },
    tabTreeClick(e) {
      //树节点点击的时候触发
      this.selectedMeasure = e;
      this.getData(); //获取数据
    },
    timeControlChange(e) {
      //时间下拉框切换时触发
      this.timeElem = e;
    },
    TimeControlClick(e) {
      //时间点击查询时
      this.timeElem = e;
      this.getData();
    },
    getSummaries(param) {
      //自定义的表格合计方法
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "节省";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          if (this.rongvalue == "-") {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return (prev - curr).toFixed(2);
              } else {
                return prev.toFixed(2);
              }
            }, 0);
          } else {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return (prev - curr).toFixed(2);
              } else {
                return prev.toFixed(2);
              }
            });
          }
        } else {
          sums[index] = "-";
        }
      });
      return sums;
    },
    cellClick(row, column, cell, event) {
      this.isLast = false;
      this.isload = true;

      let labelIndex = column.label.indexOf("月");
      if (row.name != "基本电费(需量)") {
        return;
      }
      if (labelIndex > -1) {
        this.row = row;
        this.column = column;
        this.loadIndex = Number(column.label.split("月")[0]);
        let time = new Date(this.timeElem.startTime);
        let time1 = new Date(this.timeElem.startTime);
        time.setMonth(
          Number(column.label.slice(0, column.label.length - 1)) - 1
        );
        time1.setMonth(Number(column.label.slice(0, column.label.length - 1)));
        let startTime =
          dateTool.format(new Date(time), "yyyy-MM") + "/01 00:00:00";
        let endTime =
          dateTool.format(new Date(time1), "yyyy-MM") + "/01 00:00:00";
        this.loadTime.fromDate = startTime;
        this.loadTime.toDate = endTime;
        this.fillEcharts(startTime, endTime);
      }
    },
    tableCellStyle(row, column, rowIndex, columnIndex) {
      let obj = Object.keys(row.row);
      let time = new Date(
        dateTool.getCheckRepeatTime(
          dateTool.getCurrStartTime("month"),
          "month"
        ).fromDate
      );
      let hindex = time.getMonth() + 1;
      if (this.isLast) {
        if (row.columnIndex === hindex && row.rowIndex === 1) {
          // return 'color:#00388C;background-color:#8EB5F2;;font-weight:600'
          return "color:#00388C;background-color:rgba(22, 139, 255, 0.1);font-weight:600";
        }
      }
      if (this.isload) {
        //如果之前点过单元格了，此时点击其他计量点需要保留该单元格
        if (row.columnIndex === this.loadIndex && row.rowIndex === 1) {
          // return 'color:#00388C;background-color:#8EB5F2;;font-weight:600'
          return "color:#00388C;background-color:rgba(22, 139, 255, 0.1);font-weight:600";
        }
      }
      if (this.row === row.row && this.column === row.column) {
        // return 'color:#00388C;background-color:#8EB5F2;;font-weight:600'
        return "color:#00388C;background-color:rgba(22, 139, 255, 0.1);font-weight:600";
      } else {
        return "background-color:#fff;";
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return "background-color: #F3F3F3;color: #666;";
      }
    },
    async fillEcharts(startTime, endTime) {
      //填充echarts
      this.timeTitle = startTime + "~" + endTime;
      let res = await this.$api.measuring.getMeasuringValueMaxMinDay(
        this.selectedMeasure.measureId,
        startTime,
        endTime,
        this.pointCode,
        this.pointNumber
      );
      let chartData = JSON.parse(JSON.stringify(this.chartData));
      let xData = handleData.createXData(
        "2",
        this.timeElem.startTime,
        this.timeElem.endTime
      );
      chartData[0].xData = [];
      chartData[0].data[0] = []; //最大值
      xData.forEach((item) => {
        chartData[0].xData.push(item.title);
      });
      chartData[0].timeData[0] = JSON.parse(
        JSON.stringify(fpg.getMatchTime(startTime, endTime, "2"))
      ); //匹配查询时间
      chartData[0].timeData[1] = JSON.parse(
        JSON.stringify(fpg.getMatchTime(startTime, endTime, "2"))
      ); //匹配查询时间
      chartData[0].timeData[0] = this.getMatch(
        res.data.map(k => k.max),
        chartData[0].timeData[0]
      ); //拿取匹配后的最大值
      chartData[0].data[0] = this.getValue(chartData[0].timeData[0]);
      this.chartData = chartData;
    },
    getMatch(resData, paramData) {
      //获取每个时间点对应的值  resData:接口数据   ，传送数据 paramData
      for (let i = 0; i < resData.length; i++) {
        let ele = resData[i];
        let item = paramData.find((obj) => {
          return obj.time.slice(0, 10) == ele.time.slice(0, 10);
        });
        if (item) {
          item.value = isNull(ele.value) ? "-" : ele.value.toFixed(2);
        }
      }
      return paramData;
    },
    getValue(resData) {
      //拿取value值  resData数据
      let data = [];
      resData.forEach((item) => {
        data.push(item.value);
      });
      return data;
    },
  },
};
</script>
<style lang="scss" scoped>
.jbdfyh-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  padding: 23px;
  box-sizing: border-box;
  .tree-content {
    width: 100%;
    margin-right: 14px;
  }
  .content {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .search-box {
      height: 36px;
      .option {
        width: 150px;
        margin: 0 0 0 10px;
      }
    }
    .grid-content {
      position: absolute;
      top: 50px;
      width: 100%;
      bottom: 0;
      display: flex;
      flex-flow: column;
      .table-wrap {
        flex: 1;
        width: 100%;
        margin-bottom: 14px;
        background: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 10px;
      }
      .echarts-wrap {
        flex: 1;
        width: 100%;
        background: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        .tablebox {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
